/**
 * Returns the correct Dexie database for the current context:
 * - Normal users: their own DB via getDb()
 * - Monitor-only users with a selection: the monitored person's DB
 *
 * Pages should call getActiveDb() instead of getDb() so they
 * automatically read from the right database without branching.
 */

import { getDb, type DafneUserDB } from "./user-database";
import { monitoredUserSelectionService } from "../services/monitored-user-selection";

export function getActiveDb(): DafneUserDB {
  if (monitoredUserSelectionService.isMonitorOnly) {
    const mdb = monitoredUserSelectionService.db;
    if (mdb) return mdb;
  }
  return getDb();
}
